import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work


import { saveProfile, getProfile, searchSchoolsByName } from 'services/saProfile.service';
import { updateUserAttributes, isSessionValid } from 'services/session.service';
import {
    SETTINGS_SA_PROFILE_REQUESTED,
    SETTINGS_SA_PROFILE_FAILED,
    SETTINGS_SA_PROFILE_SUCCESSFUL,
    UPDATE_SA_PROFILE_REQUESTED,
    UPDATE_SA_PROFILE_FAILED,
    UPDATE_SA_PROFILE_SUCCESSFUL,
    SETTINGS_SEARCH_SCHOOLS,
} from 'containers/Settings/actionTypes';
import {
    REQUESTED,
    FAILED,
    SUCCESSFUL,
    EDIT_SUCCESSFUL,
    EDIT_REQUESTED,
    SESSION_LOGOUT,
    SESSION_VALID,
    SCHOOL_SEARCH,
} from './actionTypes';

export function saveSAProfile(profile,id, cb) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    dispatch({
      type: UPDATE_SA_PROFILE_REQUESTED,
    });
    saveProfile(profile, id)
          .then((result) => {
            const temp = [{ Name: 'profile', Value: result.id }];
            updateUserAttributes(temp, (err) => {
              if (!err) {
                isSessionValid((thisError, data) => {
                  if (thisError) {
                    dispatch({
                      type: SESSION_LOGOUT,
                    });
                  } else {
                    const token = data.session.idToken.jwtToken;

                    dispatch({
                      type: SESSION_VALID,
                      session: fromJS(data.session),
                      user: fromJS(data.user),
                      attributes: data.attributes,
                      token,
                    });
                    dispatch({
                      type: SUCCESSFUL,
                      result: fromJS(result),
                    });
                    dispatch({
                      type: UPDATE_SA_PROFILE_SUCCESSFUL,
                      result: fromJS(result),
                    });
                    cb();
                  }
                });
              }
            });
          }).catch((err) => {
            dispatch({
              type: FAILED,
              error: err,
            });
            dispatch({
              type: UPDATE_SA_PROFILE_FAILED,
              error: err,
            });
            cb(err);
          });
  };
}

export function getSAProfile(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: EDIT_REQUESTED,
    });
    dispatch({
      type: SETTINGS_SA_PROFILE_REQUESTED,
    });
    getProfile(id)
            .then((data) => {
              if (data) {
                dispatch({
                  type: EDIT_SUCCESSFUL,
                  profile: fromJS(data),
                });
                dispatch({
                  type: SETTINGS_SA_PROFILE_SUCCESSFUL,
                  profile: fromJS(data),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
              dispatch({
                type: SETTINGS_SA_PROFILE_FAILED,
                error: err,
              });
            });
  };
}

export function searchSchools( query ) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    searchSchoolsByName({ school: query })
            .then((data) => {
              if (data) {
                dispatch({
                  type: SCHOOL_SEARCH,
                  schools: data,
                });
                dispatch({
                  type: SETTINGS_SEARCH_SCHOOLS,
                  schools: data,
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}



// WEBPACK FOOTER //
// ./src/components/GetUserDetails/actions.js